import { atomWithStorage } from 'jotai/utils';
import createStorage from '@/lib/helpers/createStorage';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';
import { DeviceType } from '@/lib/constants';

enum PageStatusEnum {
  authCodeInput = "authCodeInput",
  authCodeSubmitLoading = "authCodeSubmitLoading",
  confirmEmail = "confirmEmail",
  signIn = "signIn",
  chooseStation = "chooseStation",
  deviceRegisterLoading = "deviceRegisterLoading",
  error = "error",
  success = "success",
}

interface AppSignInState {
  authCode: string | null; // will get populated when we know it's legit
  authCodeError: string | null; // will get populated if there is an issue with the authCode
  deviceType: DeviceType | null; // will get populated when we know the authCode is legit
  favoriteStation: string | null; // the user's favorite station, as a callsign
  isPassportMember: boolean;
  pageStatus: PageStatusEnum;
  stationLogo: string | null,
  stationShortCommonName: string | null,
  uid: string | null; // will get populated if / when the user is signed in
  resetOnNextLoad: boolean;
};

const defaultAppSignInState: AppSignInState = {
  authCode: null,
  authCodeError: null,
  deviceType: null,
  favoriteStation: null,
  isPassportMember: false,
  pageStatus: PageStatusEnum.authCodeInput,
  stationLogo: null,
  stationShortCommonName: null,
  uid: null,
  resetOnNextLoad: false
};

const storage = createStorage<AppSignInState>('sessionStorage')

let storedAppSignInState = defaultAppSignInState;

if (canAccessStorage('sessionStorage') && window.sessionStorage.getItem('appSignInState')) {
  storedAppSignInState = JSON.parse(window.sessionStorage.getItem('appSignInState')!) as AppSignInState
}

const appSignInAtom = atomWithStorage<AppSignInState>('appSignInState', storedAppSignInState, storage);

export { PageStatusEnum, appSignInAtom, defaultAppSignInState };
